module.exports = __webpack_public_path__ + "img/finish.19ec7688.gif";